import { createAppAsyncThunk } from 'reduxTyped'
import { FetchAgencyFiltersError } from 'apps/agency/errors'
import { handleError } from 'shared/api/lib/errors/handlers'
import { AgencyApi } from 'shared/api/requests/agency'
import type { AgencyAgenciesFilters } from 'shared/api/requests/agency/schemas'

export const fetchAgencyFilters = createAppAsyncThunk<AgencyAgenciesFilters>(
  'agency/listing/fetchFilters',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await AgencyApi.getAgenciesFilters()

      return data
    } catch (error) {
      handleError(error, {
        scope: 'agency',
        section: 'listing',
        errorClass: FetchAgencyFiltersError,
      })

      return rejectWithValue()
    }
  },
)
